import React from 'react';

const ErrorMsg = ({
  error,
  input
}) => {
  if (error.hasOwnProperty("location")) return /*#__PURE__*/React.createElement("div", {
    className: "invalid-feedback pr-1 pl-1"
  }, /*#__PURE__*/React.createElement("b", null, input.substring(0, error.location.start.offset), /*#__PURE__*/React.createElement("mark", {
    className: "text-danger"
  }, input.substring(error.location.start.offset, error.location.end.offset)), input.substring(error.location.end.offset, input.length)), /*#__PURE__*/React.createElement("br", null), error.name + ": " + error.message);else if (error) return /*#__PURE__*/React.createElement("div", {
    className: "invalid-feedback pr-1 pl-1"
  }, error.name + ": " + error.message);else return null;
};

export default ErrorMsg;